// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable order/properties-order */
.player-stats_wrapper__3F2eB {
  z-index: 9999; /* very high to be above the player */
  position: absolute;
  top: 0;
  left: 0;
  width: 500px;
  height: 350px;

  margin: 10px;
  padding: 5px;

  display: flex;
  flex-direction: column;

  background: rgba(74, 74, 74, 0.8);
  box-shadow: 0px 4px 7px 0px rgba(74, 74, 74, 0.25);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);

  border: 1px solid rgba(74, 74, 74, 0.5);
  border-radius: 2px;

  font-size: 11px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 500;
  color: white;
}
.player-stats_wrapper__3F2eB > div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    padding-bottom: 2px;
  }
.player-stats_wrapper__3F2eB > div > div {
      flex: initial;
      width: 100px;
      text-align: right;
      padding-right: 3px;
    }
.player-stats_wrapper__3F2eB > div > span {
      flex: 1;
      max-height: 100px;
      overflow: auto;
    }
`, "",{"version":3,"sources":["webpack://./src/components/player-stats/player-stats.module.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,aAAa,EAAE,qCAAqC;EACpD,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;;EAEb,YAAY;EACZ,YAAY;;EAEZ,aAAa;EACb,sBAAsB;;EAEtB,iCAAiC;EACjC,kDAAkD;EAClD,kCAA0B;UAA1B,0BAA0B;;EAE1B,uCAAuC;EACvC,kBAAkB;;EAElB,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;AAqBd;AAnBE;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EAarB;AAXE;MACE,aAAa;MACb,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;IACpB;AACA;MACE,OAAO;MACP,iBAAiB;MACjB,cAAc;IAChB","sourcesContent":["/* stylelint-disable order/properties-order */\n.wrapper {\n  z-index: 9999; /* very high to be above the player */\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 500px;\n  height: 350px;\n\n  margin: 10px;\n  padding: 5px;\n\n  display: flex;\n  flex-direction: column;\n\n  background: rgba(74, 74, 74, 0.8);\n  box-shadow: 0px 4px 7px 0px rgba(74, 74, 74, 0.25);\n  backdrop-filter: blur(4px);\n\n  border: 1px solid rgba(74, 74, 74, 0.5);\n  border-radius: 2px;\n\n  font-size: 11px;\n  font-family: Arial, Helvetica, sans-serif;\n  font-weight: 500;\n  color: white;\n\n  & > div {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: flex;\n    padding-bottom: 2px;\n\n    & > div {\n      flex: initial;\n      width: 100px;\n      text-align: right;\n      padding-right: 3px;\n    }\n    & > span {\n      flex: 1;\n      max-height: 100px;\n      overflow: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `player-stats_wrapper__3F2eB`
};
module.exports = ___CSS_LOADER_EXPORT___;
